import { createActionGroup, props } from '@ngrx/store';
import * as fromGenerated from '../../_generated';
import { FeatureFlagView } from './feature-flags.reducer';

export const FeatureFlagsActions = createActionGroup({
  source: 'Feature Flags Actions',
  events: {
    /**
     * Load Feature Flags
     */
    'Load Feature Flags': props<{ featureFlags: FeatureFlagView[] }>(),
    /**
     * Identify User
     */
    'Identify User': props<{
      user: fromGenerated.UserView;
    }>(),
    /**
     * User Identified: LaunchDarkly evaluated every flag for the signed-in user (not the anonymous
     * boot context), so a per-user value can now be trusted.
     */
    'User Identified': props<{ featureFlags: FeatureFlagView[] }>(),
    /**
     * On Change Sync
     */
    'On Change Sync Success': props<{ featureFlags: FeatureFlagView[] }>(),
    /**
     * On Error
     */
    'On Error': props<{ error: Error }>(),
  },
});
